import type { LucideIcon } from 'lucide-react';

export interface Domain {
  id: string;
  name: string;
  logo?: string;
  primaryColor?: string;
}

export interface Tenant {
  id: string;
  name: string;
  logo: string;
  primaryColor: string; // Hex code e.g. "#3b82f6"
  secondaryColor?: string; // Optional Hex code
  domains?: Domain[];
}

export enum NavCategory {
  GENERAL = 'General',
  OPERATIONS = 'Operations',
  FINANCE = 'Finance',
  PEOPLE = 'People',
  SALES = 'Sales',
}

export interface NavItem {
  id: string;
  label: string;
  icon: LucideIcon;
  category: NavCategory;
  path?: string;
  isAction?: boolean; // If true, triggers an action instead of navigation
}

export interface UserProfile {
  name: string;
  role: string;
  avatarUrl: string;
}

export type ThemeMode = 'light' | 'dark' | 'system';